import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ICompanyPreferences } from '@shared/types/company/company-preferences.type';

export const selectCompanyFeature = createFeatureSelector<Readonly<ICompanyPreferences>>('company');

export const selectCompanyLocale = createSelector(selectCompanyFeature, (state) => ({
    locale: state.dateAndTime.locale,
}));

export const selectCompanyTimezone = createSelector(selectCompanyFeature, (state) => ({
    timezone: state.dateAndTime.timezone,
}));

export const selectCompanyIdAndName = createSelector(selectCompanyFeature, (state) => ({
    id: state.id,
    name: state.name,
}));

export const selectCompanyPrefLang = createSelector(selectCompanyFeature, (state) => state.preferred_language);

export const selectCompanyEOD = createSelector(selectCompanyFeature, (state) => state.eod);

export const selectCompanyCurrencies = createSelector(selectCompanyFeature, (state) => state.allCurrencies);

export const selectBackOfficeSetting = createSelector(selectCompanyFeature, (state) => state.backOffice);

export const selectCompanyHasChildCategories = createSelector(
    selectCompanyFeature,
    (state) => state.hasChildCategories,
);

export const selectReportGroupingMethod = createSelector(selectCompanyFeature, (state) => state.reportGroupingMethod);
